import script from "./ConfirmMoneyReceiptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmMoneyReceiptModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmMoneyReceiptModal.vue?vue&type=style&index=0&id=34ded08a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ded08a"]])

export default __exports__